// import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider, QueryClient } from "react-query";

// project-imports
import Routes from "routes";
import ThemeCustomization from "themes";

// import Loader from "components/Loader";
import Locales from "components/Locales";
import RTLLayout from "components/RTLLayout";
import ScrollTop from "components/ScrollTop";
import Customization from "components/Customization";
import Snackbar from "components/@extended/Snackbar";
import Notistack from "components/third-party/Notistack";

// import { dispatch } from "store";
// import { fetchMenu } from "store/reducers/menu";

// auth-provider
import { JWTProvider as AuthProvider } from "contexts/AuthContext";

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  // const [loading, setLoading] = useState<boolean>(true);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        //retryOnMount:
        // retry: false
      },
    },
  });

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <AuthProvider>
              <>
                <Notistack>
                  <QueryClientProvider client={queryClient}>
                    <Routes />
                    <ToastContainer />
                  </QueryClientProvider>
                  <Customization />
                  <Snackbar />
                </Notistack>
              </>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
